import React, { useState, useMemo,useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./../mystyle.css";
import { Link } from "react-router-dom";
import { a } from "framer-motion/client";

export const Films = () => {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  const products = [
    {id:'1' , dis:'', name: "JOKER",class: "action", img: "https://creativereview.imgix.net/uploads/2019/12/joker_full.jpg?auto=compress,format&crop=faces,entropy,edges&fit=crop&q=60&w=1012&h=1500" },
    {id:'2' , dis:'', name: "AVENGERS", class: "action", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYxnnMqQyMqz_sWOc-HIaB8QJu9ZeGd0ijnA&s" },
    {id:'3' , dis:'', name: "MOONLIGHT", class: "adventure", img: "https://posterhouse.org/wp-content/uploads/2021/05/moonlight_0.jpg" },
    {id:'4' , dis:'', name: "THE AFTER", class: "story", img: "https://assets.voxcinemas.com/posters/P_HO00006679.jpg" },
    {id:'5' , dis:'', name: "ALIEN", class: "adventure", img: "https://creativereview.imgix.net/uploads/2024/12/AlienRomulus-scaled.jpg?auto=compress,format&crop=faces,entropy,edges&fit=crop&q=60&w=729&h=1080" },
    {id:'6' , dis:'', name: "DUNC", class: "adventure", img: "https://preview.redd.it/what-has-happened-to-movie-posters-v0-veyma8wnnhb81.jpg?width=640&crop=smart&auto=webp&s=3155408077eb1f8e3f8c4566b44e51204bc09ba9" },
    {id:'7' , dis:'', name: "PEARL", class: "story", img: "https://substackcdn.com/image/fetch/$s_!SjlY!,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F289ad232-bb03-4b07-848c-d0dad888a4dc_2000x2963.png" },
    {id:'8' , dis:'', name: "AFTER", class: "story", img: "https://d1csarkz8obe9u.cloudfront.net/posterpreviews/movie-poster-template-design-21a1c803fe4ff4b858de24f5c91ec57f_screen.jpg?ts=1636996180" },
    {id:'9' , dis:'', name: "SPIDER MAN", class: "action", img: "https://i.redd.it/cgkzad0vcue71.jpg", },
    {id:'10' , dis:'', name: "LOVE STORY", class: "story", img: "https://c8.alamy.com/comp/RYX9YW/movie-poster-love-story-1970-RYX9YW.jpg", },
    {id:'11' , dis:'', name: "UNCHARTED", class: "action", img: "https://preview.redd.it/what-has-happened-to-movie-posters-v0-tm2y16wnnhb81.jpg?width=640&crop=smart&auto=webp&s=2f1305986475f9787ba4dd2ca1486abdb206a377"},
    {id:'12' , dis:'', name: "JUNGLE CRUISE", class: "adventure", img: "https://m.media-amazon.com/images/I/91OXM17gzXL._AC_UF894,1000_QL80_.jpg"},
    {id:'13' , dis:'', name: "HOBBS & SHAW", class: "action", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHIybZ6umH09-6J4suX89s4BGUn-CSb_4j3A&s" },
    {id:'14' , dis:'', name: "I MAX", class: "story", img: "https://atthemovies.uk/cdn/shop/products/Template_0da9b179-8079-43ae-beea-9a3a5682adfc.jpg?v=1652986446&width=1090" },
    {id:'15' , dis:'', name: "JUMAMJI", class: "adventure", img: "https://m.media-amazon.com/images/I/61KPF16khwS._AC_UF894,1000_QL80_.jpg" },
    {id:'16' , dis:'', name: "127 HOURS", class: "story", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7FcWVviECpn_lEtcLL_YzJbxweG8SsrAz6g&s" },
    {id:'17' , dis:'', name: "FREELANCE", class: "adventure", img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi3qYPU_-4O3A1whBBHj2heqlxjjNyTPbQwHWYTN-HCrTU4J5XmrDx2_BgyihfbNtJmmYOrb1w1ttnESjHVnCCx25LezNlesNla5XbN0IsHR0rzG6EvLNZY8GMK7JnVVsUJKRLU3NlHlOqQTrm7uf_iq6CZ-M9OLJyG7LMPMfm3dn5jcFVvsHTP/s2068/poster.jpg" },
];

  const [filter, setFilter] = useState("all");

  // فلترة احترافية
  const filteredProducts = useMemo(() => {
    if (filter === "random") {
      const shuffled = [...products].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 4);
    }

    if (filter === "all") return products;

    return products.filter((item) => item.class === filter);
  }, [filter]);


  const [search,setSearch] = useState('')
  const filterSearch = filteredProducts.filter( (value)=> value.name.toLowerCase().includes(search.toLowerCase()))
  
   useEffect(() => {
 
     const parallaxBox = document.getElementById("parallax");
     if (!parallaxBox) return;
 
     const layers = [];
     const speeds = [25, 20, 35, 30, 45, 30, 25, 40];
 
     for (let i = 2; i <= 9; i++) {
       const el = document.getElementById("l" + i);
       if (el) {
         layers.push({
           el,
           speed: speeds[i - 2]
         });
       }
     }
 
     const handleMove = (event) => {
       const rect = parallaxBox.getBoundingClientRect();
 
       const x = event.clientX - rect.left;
       const y = event.clientY - rect.top;
 
       const centerX = rect.width / 2;
       const centerY = rect.height / 2;
 
       layers.forEach(layer => {
         const moveX = (x - centerX) / layer.speed;
         const moveY = (y - centerY) / layer.speed;
 
         layer.el.style.transform = `translate(${moveX}px, ${moveY}px)`;
       });
     };
 
     parallaxBox.addEventListener("mousemove", handleMove);
 
     return () => {
       parallaxBox.removeEventListener("mousemove", handleMove);
     };
 
   }, []); 
  
  return (
<>
    <section className="hero-area bg-primary" id="parallax">
      <div className="container">
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <h1 className="text-white font-tertiary">FILMS</h1>
          </div>
        </div>
      </div>
      <div className="layer-bg w-100">
        <img className="img-fluid w-100" src="images/illustrations/leaf-bg.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l2">
        <img src="/images/illustrations/dots-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l3">
        <img src="/images/illustrations/leaf-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l4">
        <img src="/images/illustrations/dots-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l5">
        <img src="/images/illustrations/leaf-yellow.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l6">
        <img src="/images/illustrations/leaf-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l7">
        <img src="/images/illustrations/dots-group-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l8">
        <img src="/images/illustrations/leaf-pink-round.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l9">
        <img src="/images/illustrations/leaf-cyan-2.png" alt="bg-shape" />
      </div>
      <ul className="list-unstyled ml-5 mt-3 position-relative zindex-1">
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-facebook"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-instagram"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-dribbble"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-twitter"></i></a></li>
      </ul>
    </section>
    <section style={{marginTop:'10%'}} className="section">
      <div className="container">
      <h1 style={{textAlign:'center',paddingBottom:'20px'}}>FILMS</h1>
      <form className="d-flex" role="search">
        <input onChange={(e) => setSearch(e.target.value)} value={search} style={{fontSize:"18px"}} className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
      </form>
        {/* Buttons */}
        <div className="text-center mb-4 pt-4">
          {["all", "action", "story", "adventure"].map((type) => (
            <button
              key={type}
              onClick={() => setFilter(type)}
              className={`btn btn-sm m-1 ${
                filter === type ? "btn-primary" : "btn-outline-primary"
              }`}
            >
              {type.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Products */}
        <motion.div layout className="row">
          <AnimatePresence>
            {filterSearch.map((item) => (
              <motion.div
                key={item.name}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.4 }}
                className="col-lg-3  col-sm-6 mb-4"
              >
                <div className="card card-container shadow text-center">
                  <img
                  className="img"
                    src={item.img}
                    alt={item.name}
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "cover"
                    }}
                  />
                  <Link to={`/details/${item.id}`|| "/"}> <button className='btn btn-primary view'>view</button> </Link>
                  <div className="card-footer bg-white">
                    <h5>{item.name}</h5>
                    <small className="text-muted">{item.class}</small>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

      </div>
      <hr></hr>
    </section>
 </> 
  );
};

export default Films;







